import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { API, CullDTO } from 'src/app/services/api/api';
import { ErrorService } from 'src/app/services/error.service';
import { UtilService } from 'src/app/services/util.service';
import { TableWrapperOptions } from '../../../../services/global/global-interfaces';
import { PermissionService } from '../../../../services/permission.service';

@Component({
  selector: 'sb-page-company-details-culls',
  templateUrl: './company-details-culls.component.html',
  styleUrls: ['./company-details-culls.component.scss'],
  standalone: false,
})
export class CompanyDetailsCullsComponent implements OnInit {
  companyId: number;
  loading: boolean;

  options: TableWrapperOptions;
  culls: CullDTO[] = [];
  debounceTimer: ReturnType<typeof setTimeout>;

  constructor(
    private api: API,
    private activatedRoute: ActivatedRoute,
    public util: UtilService,
    public errorHandler: ErrorService,
    public permissionService: PermissionService
  ) {
    this.companyId = undefined;
    this.loading = true;
    this.culls = [];
    this.debounceTimer = null;
  }

  ngOnInit() {
    this.activatedRoute.parent.params.subscribe(params => {
      this.companyId = +params.companyID;
    });
  }

  requestDebounced(options?: TableWrapperOptions) {
    if (options) {
      this.options = options;
    }
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.refreshFromServer();
    }, 500);
  }

  refreshFromServer() {
    if (this.options?.pagination) {
      this.loading = true;
      this.api
        .cs_Cull_retrieveAll(
          {
            search: this.util.encodeSearchQueryParam(this.options.exactMatch, this.options.search),
            company: [this.companyId],
          },
          this.options.pagination
        )
        .subscribe({
          next: (res: CullDTO[]) => {
            this.culls = res;
            this.loading = false;
          },
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });
    }
  }
}
